import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from './favorite-truck.reducer';

export const FavoriteTruckDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const favoriteTruckEntity = useAppSelector(state => state.favoriteTruck.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="favoriteTruckDetailsHeading">
          <Translate contentKey="fleetSenseApp.favoriteTruck.detail.title">FavoriteTruck</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{favoriteTruckEntity.id}</dd>
          <dt>
            <span id="favorited">
              <Translate contentKey="fleetSenseApp.favoriteTruck.favorited">Favorited</Translate>
            </span>
          </dt>
          <dd>{favoriteTruckEntity.favorited ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.favoriteTruck.user">User</Translate>
          </dt>
          <dd>{favoriteTruckEntity.user ? favoriteTruckEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.favoriteTruck.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{favoriteTruckEntity.truckImplement ? favoriteTruckEntity.truckImplement.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/favorite-truck" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/favorite-truck/${favoriteTruckEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FavoriteTruckDetail;
